export default { // 该需求云运行在合伙人app，入口在线车位
  tabs: [{
    name: 'carlist',
    path: '/carlist',
    component: () => import('./src/carlist.vue'),
    meta: {
      title: '在线车位',
      isMenu: true
    }
  },
  {
    name: 'carDetail',
    path: '/carDetail/:authId',
    component: () => import('./src/cardetail.vue'),
    meta: {
      title: '上架车辆明细',
      isMenu: true
    }
  },
  {
    name: 'setCarLimit',
    path: '/setCarLimit/:authId',
    component: () => import('./src/setCarLimit.vue'),
    meta: {
      title: '车辆上架限制设置',
      isMenu: true
    }
  }]
}
